<template>
  <Accordion :defaultOpen="accordionDefaultOpen">
    <template #header>
      <p class="small accent">
        {{ t('label_advanced_settings') }}
      </p>
    </template>
    <template #default>
      <Info2Column title="">
        <Checkbox v-model="isActiveAdvancedSettings">
          {{ t('button_use_advanced_settings') }}
        </Checkbox>
      </Info2Column>

      <Info2Column v-for="option in gaugeOptions" :key="option.key" :title="option.title">
        <Gauge
          v-model="advancedOptions![option.key]"
          :min="option.min"
          :max="option.max"
          :min-label="option.minLabel"
          :max-label="option.maxLabel"
          :disabled="!isActiveAdvancedSettings"
        />
      </Info2Column>
    </template>
  </Accordion>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import Accordion from '@/components/shared/base/Accordion.vue';
import Checkbox from '@/components/shared/base/Checkbox.vue';
import Gauge from '@/components/shared/base/Gauge.vue';
import Info2Column from '@/components/shared/composite/Info2Column.vue';
import { AdvancedOptions, GaugeOption } from '@/types/components';

const { t } = useI18n();

const isActiveAdvancedSettings = defineModel<boolean>('isActiveAdvancedSettings');
const advancedOptions = defineModel<AdvancedOptions>('advancedOptions', {
  required: true,
  default: () => ({
    TSS: 0,
    VAD: 0,
    SIL: 0,
  }),
});
const gaugeOptions = defineModel<Array<GaugeOption>>('gaugeOptions', {
  required: true,
  default: () => [],
});

defineProps({
  accordionDefaultOpen: Boolean,
});
</script>

<style scoped></style>
